import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=6cd96c13"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd96c13')) {
      api.createRecord('6cd96c13', component.options)
    } else {
      api.reload('6cd96c13', component.options)
    }
    module.hot.accept("./Resource.vue?vue&type=template&id=6cd96c13", function () {
      api.rerender('6cd96c13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Resource.vue"
export default component.exports